import { store } from '../../App'
import { FAIL_FETCH } from './Other'

export const FETCH_OVERVIEW = 'FETCH_OVERVIEW'
export const LOAD_OVERVIEW = 'LOAD_OVERVIEW'

/**
  * fetchOverview
  * @param {string} ID
  * @param {timestamp} start
  * @param {timestamp} end
  * @param {Object} options
  * @return {action} fetchOverviewAction
*/
export function fetchOverview (ID, start, end, options) {
  const query = { accountId: ID, startDate: start, endDate: end }

  if (options.profile && options.profile[0].length > 0) {
    query.appProfileIds = options.profile
  } else {
    if (store.getState().filterSources.profiles[0] && store.getState().filterSources.profiles[0]._id === '0') {
      return { type: FAIL_FETCH }
    }
    query.appProfileIds = store.getState().filterSources.profiles.map(profile => profile._id)
  }

  if (options.group && options.group[0].length > 0) {
    query.groupIds = options.group
  } else {
    if (store.getState().filterSources.profiles[0] && store.getState().filterSources.profiles[0]._id === '0') {
      return { type: FAIL_FETCH }
    }
    query.groupIds = ['AllGROUPS']
  }

  return { type: FETCH_OVERVIEW, query }
}

/**
  * loadOverview
  * @param {Object} data
  * @return {action} loadOverviewAction
*/
export function loadOverview (data) {
  return { type: LOAD_OVERVIEW, data }
}
